import React from 'react';
import { Box } from '@chakra-ui/react';
import { Loading as LoadingIcon } from '../../../../context/Chakra/Icons';

const Loading = () => {
  return (
    <Box textAlign="center">
      <LoadingIcon />
    </Box>
  );
};

export default Loading;
